import React, { useState, useEffect, useCallback, useRef } from 'react';
import './../../App.css';
import './Employees.css';
import { CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import {SetAuditTrail} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {token, domain} from './../Security';
import loadingSpinner from './../../assets/loading.gif';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import {useTable, useSortBy} from 'react-table';
import {globalTimeFormat} from './../Security';
import { format } from 'date-fns';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import SaveIcon from '@mui/icons-material/Save';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
// import CancelIcon from '@mui/icons-material/Cancel';

function UploadedSchedule({user, userAccess, isHideSideMenu}) {
    const [currentPage, setCurrentPage] = useState(1);
    const [showSetting, setShowSetting] = useState(false);
    const settingRef = useRef(null);
    const buttonRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [loadingUploadRequest, setLoadingUploadRequest] = useState(false);
    const [employeeSchedule, setEmployeeSchedule] = useState([]);
    const [showUploadForm, setShowUploadForm] = useState(false);

    // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [payrollPeriodFilter, setPayrollPeriodFilter] = useState("");

    // Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [employeeId, setEmployeeId] = useState("");
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeeFullName, setEmployeeFullName] = useState("");
    const [shiftScheduleId, setShiftScheduleId] = useState("");
    const [shiftSchedule, setShiftSchedule] = useState("");
    const [oldShiftSchedule, setOldShiftSchedule] = useState("");
    const [selectedData, setSelectedData] = useState(null);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const fetchDataForEmployee = useCallback(async () => {
        const apiUrl =  domain + `/api/Employee/single-data`;

        try {
            const response = await axios.post(apiUrl, user, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [user]);
    const fetchDataForShiftSchedule = useCallback(async () => {
        const apiUrl =  domain + "/api/ShiftSchedule/";

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []);

    const [isGenerate, setIsGenerate] = useState(false);
    
    const fetchData = useCallback(async () => {
        // if(!isGenerate) return;
        const apiUrl =  domain + `/api/ChangeScheduleRequest/uploaded-schedule/payrollPeriod/${payrollPeriodFilter}/employee/${user.employeePersonalInformationId}`;

        try {
            setLoading(true);
            const response = await axios.get( apiUrl, {
            // const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            console.log("response.data", response.data)
            
            setEmployeeSchedule(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [payrollPeriodFilter, user.employeePersonalInformationId]);

    const generateHandleClick = async () =>{
        if(!payrollPeriodFilter){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Please select payroll period");
            return;
        }

        setLoading(true);

        await fetchData();
        
        setIsGenerate(true)
        setLoading(false);
    }

    /* useEffect(() => {
        if(isGenerate){
            fetchData();
        }
    }, [isGenerate, fetchData]) */

    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        setCurrentPage(1);

        // Return all results that match either employee name or ID
        const res = filterData.filter((f) =>
            f.employeeFullName.toLowerCase().includes(lowercaseValue) ||
            f.employeeId.toString().toLowerCase().includes(lowercaseValue)
        );

        setEmployeeSchedule(res);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
    
        const apiUrl =  domain + `/api/ChangeScheduleRequest/update-upload-schedule/${selectedData.id}`;

        if (!shiftScheduleId) {
            alert("Required to fill up all data");
            return; // Exit early if fields are empty
        }

        const data = {
            employeePersonalInformationId: employeePersonalInformationId,
            employeeId: employeeId,
            employeeFullName: employeeFullName,
            shiftScheduleId: shiftScheduleId,
            shiftSchedule: shiftSchedule
        };

        try {
            await axios.put(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            setShowEditForm(false); // Hide the add form

            await SetAuditTrail({
                setupArea: "Employee Schedule", 
                actionTaken: "update", 
                field: "Shift Schedule", 
                newValue: shiftSchedule, 
                oldValue: oldShiftSchedule, 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await fetchData();

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployeePersonalInformationId("");
            setEmployeeId("");
            setEmployeeFullName("");
            setShiftScheduleId("");
            setShiftSchedule("");
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }

        setShowEditForm(false);
    };

    const [dataToEdit, setDataToEdit] = useState(null); 
    const editHandleClick = (data) => {
        //(true);
        setSelectedData(data);
        setEmployeePersonalInformationId(data.employeePersonalInformationId);
        setEmployeeId(data.employeePersonalInformationEmployeeId);
        setEmployeeFullName(data.employeePersonalInformationFullName);
        setShiftScheduleId(data.shiftScheduleToId);

        const _shiftSchedule = {
            shiftName: data.shiftScheduleToShiftName,
            timeFrom: data.shiftScheduleToTimeFrom,
            timeTo: data.shiftScheduleToTimeTo,
        }
        setShiftSchedule(_shiftSchedule);
        setOldShiftSchedule(_shiftSchedule);
    };
    function convertToBulkArray(bulkData) {
        const { employeePersonalInformationId, ...rest } = bulkData;

        const result = Object.keys(rest)
            .filter(key => key.match(/^\d{4}-\d{2}-\d{2}$/)) // only date keys
            .map(dateKey => ({
            employeePersonalInformationId,
            date: dateKey,
            dataId: rest[dateKey]?.id || null,
            shiftScheduleId: rest[dateKey]?.shiftId || null,
            uploaderId: user.id
            }));

        return result;
    }
    const handleUpdate = async () => {
        const apiUrl =  domain + `/api/ChangeScheduleRequest/update-upload-schedule-bulk/`;
        setLoading(true);

        const bulkArray = convertToBulkArray(dataToEdit);
        
        try {
            await axios.post(apiUrl, bulkArray, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            await fetchData();

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const closeEditHandleClick = () => {
        setShowEditForm(false);
        setSelectedData(null);
    };
    const openUploadFormHandleClick  = () =>{
        setShowUploadForm(true);
    }
    const closeUploadFormHandleClick = () =>{
        setShowUploadForm(false);
    }

    function formatTime(timeString) {
        const date = new Date(timeString);
    
        // Extract hours and minutes
        let hours = date.getHours();
        const minutes = date.getMinutes();
    
        // Determine AM or PM suffix
        const ampm = hours >= 12 ? 'PM' : 'AM';
    
        // Convert to 12-hour format
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
    
        // Format minutes to always be two digits
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    
        // Return formatted time
        return `${hours}:${formattedMinutes} ${ampm}`;
    }

    const generateDownloadTemplate = useCallback(async (employees, payrollPeriod) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet1 = workbook.addWorksheet('EmployeeSchedule');
        const shiftScheduleData = await fetchDataForShiftSchedule();

        // --- Helper: Generate date range ---
        const generateDateRange = (start, end) => {
            const dateArray = [];
            let currentDate = new Date(start);
            const endDate = new Date(end);
            while (currentDate <= endDate) {
                dateArray.push(new Date(currentDate));
                currentDate.setDate(currentDate.getDate() + 1);
            }
            return dateArray;
        };

        const dateList = generateDateRange(payrollPeriod.dateFrom, payrollPeriod.dateTo);

        // --- Build header row ---
        const header = ['EmployeeId', 'EmployeeName', ...dateList.map(d => formatDateToMMDDYYYY(d))];
        const headerRow = worksheet1.addRow(header);

        worksheet1.columns = header.map(() => ({ width: 20 }));

        // Format header cells
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        // --- Add employee rows ---
        employees.forEach((info) => {
            const rowValues = [info.employeeId, info.fullName];
            worksheet1.addRow(rowValues);
        });

        // --- Create dropdown list source ---
        // `${info.id} - ${info.shiftName} (${formatTime(info.timeFrom)} - ${formatTime(info.timeTo)})`
        
        const dropdownOptions = shiftScheduleData.map(info => 
            `${info.id} - ${info.shiftName} ${` ${info.timeFrom && info.timeTo ? `(${formatTime(info.timeFrom)} - ${formatTime(info.timeTo)})` : "" }`}`
        );

        const hiddenSheet = workbook.addWorksheet('Hidden_ShiftList');
        hiddenSheet.state = 'veryHidden';

        dropdownOptions.forEach((option, index) => {
            hiddenSheet.getCell(`A${index + 1}`).value = option;
        });

        const totalOptions = dropdownOptions.length;
        const listFormula = `Hidden_ShiftList!$A$1:$A$${totalOptions}`;

        // --- Apply dropdown to all date columns ---
        const startRow = 2; // data starts at row 2
        const endRow = employees.length + 1;
        const startCol = 3; // column C = first date

        for (let row = startRow; row <= endRow; row++) {
            for (let col = startCol; col < startCol + dateList.length; col++) {
                const cell = worksheet1.getCell(row, col);
                cell.dataValidation = {
                    type: 'list',
                    allowBlank: true,
                    formulae: [listFormula],
                    showDropDown: true,
                    showErrorMessage: true,
                    errorTitle: 'Invalid Selection',
                    error: 'Please select a valid shift schedule from the list.',
                };
            }
        }

        // --- Export file ---
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(blob, 'Employee_Schedule_Template.xlsx');
    }, [fetchDataForShiftSchedule]);

    // --- Helper function for date formatting ---
    function formatDateToMMDDYYYY(date) {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }

    const [uploadEmployees_temp, setUploadEmployees_temp] = useState([])
    const uploadEmployeeData = async (file) => {
        setLoadingUploadRequest(true);
        const dataEmployee = await fetchDataForEmployee();
        const dataShiftSchedule = await fetchDataForShiftSchedule();
    
        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value;
        }

        function validateData(data) {
            let newData = [];
        
            data.forEach((item, index) => {
                const missing = [];
                
                if (!item.employeeId) missing.push('Employee Id');
                if (!item.shiftScheduleId) missing.push('Shift Schedule');
                if (!item.date) missing.push('Date');
        
                // ✅ Construct error message properly
                let errorMessage = "";

                const existingEmployee = dataEmployee.find(employee => employee.employeeId === item.employeeId?.toString());
                if (!existingEmployee) {
                    errorMessage += errorMessage?.length > 0 ? ` Employee Id does not exist` : `Employee Id does not exist. `;
                }

                // ✅ Validate Date format (must be valid mm/dd/yyyy)
                const date = new Date(item.date);
                if (isNaN(date.getTime())) {
                    errorMessage += (errorMessage ? " " : "") + "Invalid value - Date.";
                }
        
                if (missing?.length > 0) {
                    errorMessage += ` Missing fields - ${missing.join(', ')}`;
                }
        
                newData.push({ ...item, errors: errorMessage });
            });
            
            newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

            return newData;
        }

        const convertToDateTime = (value) => {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return null;
            }

            if(!value){
                return null;
            }

            if (typeof value === 'number') {
                // Convert Excel serial number to JavaScript Date
                const excelStartDate = new Date(1899, 11, 31); // Correct base date
                const jsDate = new Date(excelStartDate.getTime() + value * 86400000); // Convert days to milliseconds
                
                return jsDate.toISOString().split('T')[0];
            }

            if (typeof value === 'string') {
                let formattedValue = value.replace(/-/g, '/'); // Ensure compatibility
                
                const parts = formattedValue.split('/');
                if (parts?.length === 3) {
                    let [first, second, third] = parts.map(p => parseInt(p, 10));
        
                    let year, month, day;
        
                    if (third > 31) {
                        // Case: YYYY/MM/DD (Ensure proper year detection)
                        year = third;
                        month = first;
                        day = second;
                    } else if (first > 12) {
                        // Case: DD/MM/YYYY (Auto-detect)
                        day = first;
                        month = second;
                        year = third;
                    } else {
                        // Case: MM/DD/YYYY (US format)
                        month = first;
                        day = second;
                        year = third;
                    }
        
                    return new Date(Date.UTC(year, month - 1, day)).toISOString().split('T')[0]; // Return YYYY-MM-DD
                }
            }

            return null
        }
    
        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const informations = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

            let bulkData = [];
    
            informations.forEach(info => {
                const employeeId = sanitizeValue(info.EmployeeId)?.toString();
                const employeeName = sanitizeValue(info.EmployeeName);

                if (!employeeId || !employeeName) return; // skip invalid rows

                const foundEmployee = dataEmployee.find(
                    (data) => data.employeeId.toLowerCase() === employeeId.toLowerCase()
                );

                // Loop through all keys (columns)
                Object.keys(info).forEach((key) => {
                    // Skip non-date columns
                    if (key === "EmployeeId" || key === "EmployeeName") return;

                    const shiftScheduleValue = sanitizeValue(info[key]);
                    if (!shiftScheduleValue) return; // skip empty cells

                    // Parse shift schedule ID (e.g., "6 - MEDUSA MID SHIFT ...")
                    const shiftScheduleId = shiftScheduleValue.split(" ")[0];
                    const foundShiftSchedule = dataShiftSchedule.find(
                        (s) => s.id.toString() === shiftScheduleId.toString()
                    );

                    // Convert header (e.g., "08/29/2025") to date (YYYY-MM-DD)
                    const date = convertToDateTime(key);

                    // Push one entry per date column
                    bulkData.push({
                        employeeId,
                        fullName: employeeName,
                        employeePersonalInformationId: foundEmployee ? sanitizeValue(foundEmployee.id) : 0,
                        date,
                        shiftScheduleId: foundShiftSchedule ? sanitizeValue(foundShiftSchedule.id) : null,
                        shiftSchedule: shiftScheduleValue,
                        uploaderId: user.id,
                    });
                });
            });

            const validatedData = validateData(bulkData);
            const sortedData = validatedData.sort((a, b) => {
                const hasErrorA = a.errors && a.errors?.length > 0;
                const hasErrorB = b.errors && b.errors?.length > 0;
            
                return hasErrorB - hasErrorA; // Move items with errors to the top
            });
            
            setUploadEmployees_temp(sortedData);
    
        };
    
        setLoadingUploadRequest(false);
        reader.readAsArrayBuffer(file);
    };
    function handleFileUpload(files) {
        if (!files || files?.length === 0) {
            console.error('No files selected');
            return;
        }

        const file = files[0];
        uploadEmployeeData(file);
    }
    const handleFinalFileUpload = async (bulkData) => {
        setLoadingRequest(true);
    
        const apiUrl = `${domain}/api/ChangeScheduleRequest/upload-schedule-bulk`;

        console.log('Final bulkData:', JSON.stringify(bulkData, null, 2));
            
        try {
            await axios.post(apiUrl, bulkData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            await SetAuditTrail({
                setupArea: "Employee Schedule", 
                actionTaken: "upload", 
                field: "Upload Employee Schedule", 
                newValue: "[bulk data]", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await fetchData();
            
            setLoadingRequest(false);
            setRequestMessage('Upload successful');
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = error.response?.data?.message || 'An error occurred';
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    }

    const handleSetting = () =>{
        setShowSetting(!showSetting);
    };

    useEffect(() => {
        var settingIcon = document.getElementById("setting-icon");

        if(showSetting){
            //change the down icon to up
            settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
        } else {
            //change the up icon to down
            settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
        }

        const handleClickOutside = (event) => {
            if (settingRef.current && !settingRef.current.contains(event.target)) {
                if(buttonRef.current && !buttonRef.current.contains(event.target)){
                    setShowSetting(false);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };


    }, [showSetting]);

    const [showDownloadTemplateForm, setShowDownloadTemplateForm] = useState(false);
    const openDownloadTemplateForm = () => {
        setShowDownloadTemplateForm(true);
    }
    const closeDownloadTemplateForm = () => {
        setShowDownloadTemplateForm(false);
    }

    const [showViewScheduleForm, setShowViewScheduleForm] = useState(false)
    const openViewScheduleForm = () => {
        setShowViewScheduleForm(true)
    }
    const closeViewScheduleForm = () => {
        setShowViewScheduleForm(false)
    }
    const viewSchedule = (data) =>{
        setSelectedData(data)
        openViewScheduleForm()
    }

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Personnel >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Uploaded Schedule"}</span>
                            </div>
                            <div className='row' style={{justifyContent: "space-between", alignItems: "center"}}>
                                <h3>Uploaded Schedule</h3>
                                <div className='hidden' style={{width:"30%",textAlign:"right"}}>
                                    <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                                        <SettingsIcon/>
                                        <KeyboardArrowDownIcon id="setting-icon"/>
                                    </button>
                                    <div ref={settingRef}>
                                        {showSetting && 
                                            <SettingInit
                                            // generateDownloadTemplate={generateDownloadTemplate}
                                            generateDownloadTemplate={openDownloadTemplateForm}
                                            openUploadFormHandleClick={openUploadFormHandleClick}
                                            />}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="employeesTab-body">
                            <div className='filters-payroll'>
                                <span>Filter</span>
                                <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px", justifyContent: "normal"}}>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Payroll Period</div>
                                        <div className="info-item-input">
                                            <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodFilter} setPayrollPeriodId={setPayrollPeriodFilter}/>
                                        </div>
                                    </div>
                                </div>
                                <button className='bg-blue-500 hover:bg-blue-600 text-white border-none rounded-sm py-2 px-4 cursor-pointer'
                                    onClick={generateHandleClick}
                                >
                                    GENERATE
                                </button>
                            </div>
                            <div className="body-top row">
                                <div className="body-top-search">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                    "mainte-search row", 
                                                                    "mainte-search-icon", 
                                                                    "mainte-search-input", 
                                                                    (e)=>handleFilter(e.target.value), 
                                                                    "Search", 
                                                                    SearchIcon)}
                                </div>
                            </div>
                                {isGenerate ?
                                <div className="employeesTab-table container">
                                    <CreateTable2
                                        dataList={employeeSchedule}
                                        editHandleClick={editHandleClick}
                                        viewSchedule={viewSchedule}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                        payrollPeriodFilter={payrollPeriodFilter}
                                        dataToEdit={dataToEdit} setDataToEdit={setDataToEdit}
                                        handleUpdate={handleUpdate}
                                    />
                                </div>
                                :
                                <div className='w-full text-center' 
                                    style={{border: "1px solid #80808050", overflow: "hidden"}}
                                >
                                    <div className='m-5'>
                                    No data to display. Please generate data.
                                    </div>
                                </div>
                                }
                        </div>
                    </div>
                </div>
            </div>
            {showEditForm &&
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    employeePersonalInformationId={employeePersonalInformationId}
                    employeeFullName={employeeFullName}
                    shiftSchedule={shiftSchedule}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    setEmployeeFullName={setEmployeeFullName}
                    setShiftSchedule={setShiftSchedule}
                    setShiftScheduleId={setShiftScheduleId}
                    shiftScheduleId={shiftScheduleId}
                    handleSubmit={handleSubmit}
            >
            </EditForm>}
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    uploadEmployees_temp={uploadEmployees_temp}
                    setUploadEmployees_temp={setUploadEmployees_temp}
                    handleFileUpload={handleFileUpload}
                    handleFinalFileUpload={handleFinalFileUpload}
            >
            </UploadForm>
            <DownloadTemplateForm  isOpen={showDownloadTemplateForm} 
                    onClose={closeDownloadTemplateForm}
                    generateDownloadTemplate={generateDownloadTemplate}
                    user={user}
            >
            </DownloadTemplateForm>
            <ViewScheduleForm  isOpen={showViewScheduleForm} 
                    onClose={closeViewScheduleForm}
                    selectedData={selectedData} setSelectedData={setSelectedData}
                    employeeSchedule={employeeSchedule}
                    user={user}
                    fetchData={fetchData}
            >
            </ViewScheduleForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            
            {loadingRequest || loading? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
            {loadingUploadRequest ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "10000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function DownloadTemplateForm({isOpen, 
    onClose,
    generateDownloadTemplate,
    user
}) 
{
    const [errorState, setErrorState] = useState(false);
    const [loading, setLoading] = useState(false);
    const [classificationFilter, setClassificationFilter] = useState(0);
    const [locationFilter, setLocationFilter] = useState(0);
    const [payrollPeriodFilter, setPayrollPeriodFilter] = useState("");

    const fetchEmployeeData = useCallback(async () => {
        const apiUrl =  domain + `/api/Employee/basic-info/all/active`;

        try {
            const response = await axios.post(apiUrl, user, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, [user]);

    const fetchPayrollPeriodData = useCallback(async () => {
        const apiUrl =  domain + `/api/PayrollPeriod/${payrollPeriodFilter}`;

        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
            }})
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return null;
        }
    }, [payrollPeriodFilter]);

    const submit = async (e) =>{
        if(!payrollPeriodFilter){
            setErrorState(true);
            return;
        }

        setLoading(true)

        const employees = await fetchEmployeeData();
        const payrollPeriod = await fetchPayrollPeriodData();
        generateDownloadTemplate(employees, payrollPeriod)
        
        setLoading(false)

        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        setErrorState(false);
        setLoading(false);
        setClassificationFilter(0);
        setLocationFilter(0);
        setPayrollPeriodFilter("");
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Download Tempalte Form</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodFilter} setPayrollPeriodId={setPayrollPeriodFilter}/>
                            </div>
                            <span style={{
                                        visibility: !payrollPeriodFilter && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Classification</div>
                            <div className="info-item-input">
                                <ClassificationIdSelect classificationId={classificationFilter} setClassificationId={setClassificationFilter}/>
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Location</div>
                            <div className="info-item-input">
                                <LocationIdSelectWithAll locationId={locationFilter} setLocationId={setLocationFilter}/>
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={submit}
                        >
                                DOWNLOAD
                        </button>
                    </div>
                </div>
            )}
            </div>

            {loading? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </>
    );
}
function ViewScheduleForm({isOpen, 
    onClose,
    selectedData, setSelectedData,
    employeeSchedule,
    user,
    fetchData,
}){
    var header = [
        "Date",
        "Shift Schedule",
        "Time From",
        "Time To",
        "",
    ]
    var accessor = [
        "dateFrom",
        "shiftScheduleToShiftName",
        "shiftScheduleToTimeFrom",
        "shiftScheduleToTimeTo",
        "manage"
    ]

    const [selectedSched, setSelectedSched] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const [date, setDate] = useState("");
    const [shiftScheduleId, setShiftScheduleId] = useState("")

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const resetLocalVariables = () => {
        setCurrentPage(1);
        setDate("");
        setShiftScheduleId("");
        setLoading(false);
        setSelectedSched(null);
    }

    const handleClose = () => {
        onClose();
        resetLocalVariables()
    };

    const [showAddForm, setShowAddForm] = useState(false)
    const openAddForm = () => {
        setShowAddForm(true);
    }
    const closeAddForm = () => {
        setShowAddForm(false);
        resetLocalVariables()
    }
    const handleSubmit = async () => {
        const apiUrl =  domain + `/api/ChangeScheduleRequest/upload-schedule`;

        const data = {
            employeePersonalInformationId: selectedData.employeePersonalInformationId,
            date: date,
            shiftScheduleId: shiftScheduleId,
            uploaderId: user?.id
        };

        try {
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            await fetchData();

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }
    };

    const [showEditForm, setShowEditForm] = useState(false)
    const openEditForm = () => {
        setShowEditForm(true);
    }
    const closeEditForm = () => {
        setShowEditForm(false);
        resetLocalVariables()
    }

    const editHandleClick = (data) => {
        setSelectedSched(data);
        setDate(data.dateTo);
        setShiftScheduleId(data.shiftScheduleToId);
        openEditForm()
    }
    const handleUpdate = async () => {
        const apiUrl =  domain + `/api/ChangeScheduleRequest/update-upload-schedule/${selectedSched.id}`;

        const data = {
            employeePersonalInformationId: selectedSched.employeePersonalInformationId,
            date: date,
            shiftScheduleId: shiftScheduleId,
        };

        try {
            await axios.put(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            setShowEditForm(false); // Hide the add form

            await fetchData();

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }
    };

    useEffect(() => {
        if(isOpen){
            const foundData = employeeSchedule.find(i => i.id === selectedData.id);
            setSelectedData(foundData)
        }
    }, [isOpen, employeeSchedule, selectedData, setSelectedData])

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Schedule</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="transaction-addBtn row" style={{margin: "10px 0"}}>
                            {CreateButton("", "add row", openAddForm, "ADD", NoteAddIcon)}
                        </div>
                        <div className="employeesTab-table container">
                            <CreateTable
                                dataList={selectedData?.schedules}
                                dataHeader={header}
                                dataAccessor={accessor}
                                editHandleClick={editHandleClick}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>
            <AddUpdateScheduleForm 
                isOpen={showAddForm}
                onClose={closeAddForm}
                date={date} setDate={setDate}
                shiftScheduleId={shiftScheduleId} setShiftScheduleId={setShiftScheduleId}
                modalName={"Add Schedule"}
                handleSubmit={handleSubmit}
            />
            <AddUpdateScheduleForm 
                isOpen={showEditForm}
                onClose={closeEditForm}
                date={date} setDate={setDate}
                shiftScheduleId={shiftScheduleId} setShiftScheduleId={setShiftScheduleId}
                modalName={"Update Schedule"}
                handleSubmit={handleUpdate}
            />
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading ? (
                <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </>
    );
}
function EditForm({isOpen, 
    onClose,
    employeePersonalInformationId,
    employeeFullName,
    shiftSchedule,
    setEmployeePersonalInformationId,
    setEmployeeFullName, 
    setShiftSchedule, 
    setShiftScheduleId,
    shiftScheduleId,
    handleSubmit}) 
{
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Employee Schedule</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <input
                                readOnly
                                id="employeePersonalInformationId"
                                placeholder="Employee Id"
                                value={employeeFullName}
                                style={{cursor:"not-allowed"}}
                                />
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Shift Schedule</div>
                            <div className="info-item-input">
                                <ShiftScheduleIdSelect shiftScheduleId={shiftScheduleId} setShiftScheduleId={setShiftScheduleId}/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleSubmit}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function AddUpdateScheduleForm({isOpen, 
    onClose,
    date, setDate,
    shiftScheduleId, setShiftScheduleId,
    modalName,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = () => {
        if(!date || !shiftScheduleId){
            setErrorState(true);
            return;
        }

        handleSubmit()
        handleClose()
    }
    const handleClose = () => {
        onClose();
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{modalName}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date</div>
                            <div className="info-item-input">
                                <DateTimeInput date={date} setDate={setDate}/>
                            </div>
                            <span style={{
                                visibility: !date && errorState ? "visible" : "hidden",
                                color:"#ff6565", 
                                fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Shift Schedule</div>
                            <div className="info-item-input">
                                <ShiftScheduleIdSelect shiftScheduleId={shiftScheduleId} setShiftScheduleId={setShiftScheduleId}/>
                            </div>
                            <span style={{
                                visibility: !shiftScheduleId && errorState ? "visible" : "hidden",
                                color:"#ff6565", 
                                fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={submit}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function SettingInit({
    generateDownloadTemplate,
    openUploadFormHandleClick,
}){
    return(
        <div id='payroll-setting' className="payroll-setting column">
            <div className="payroll-setting-item row" onClick={()=>generateDownloadTemplate(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Template
            </div>
            <div className="payroll-setting-item row"onClick={()=>openUploadFormHandleClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Employee Schedule
            </div>
        </div>
    )
}
function UploadForm({isOpen, 
    onClose,
    uploadEmployees_temp,
    setUploadEmployees_temp,
    handleFileUpload,
    handleFinalFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
        setUploadEmployees_temp([]);
    };

    const [files, setFiles] = useState([]);
    const [currentFiles, setCurrentFiles] = useState([]);
    const [hasNoError, setHasNoError] = useState(false);

    useEffect(() => {
        if(uploadEmployees_temp?.length > 0){
            const _errorData = uploadEmployees_temp.filter(i => i.errors?.length > 0)

            if(_errorData?.length <= 0){
                setHasNoError(true)
            } else {
                setHasNoError(false)
            }
        }
    }, [uploadEmployees_temp])

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
        setUploadEmployees_temp([]);
    };

    useEffect(() => {
        if(currentFiles !== files){
            setCurrentFiles(files)
            handleFileUpload(files);
        }
    }, [files, handleFileUpload, currentFiles])

    const submit = (e) =>{
        handleFinalFileUpload(uploadEmployees_temp);
        handleClose();
    };

    const [currentPage, setCurrentPage] = useState(1);
    var header = [
        "Employee Id",
        "Employee Name",
        "Date",
        "Shift Schedule",
        "Error",
    ]
    var accessor = [
        "employeeId",
        "fullName",
        "date",
        "shiftSchedule",
        "errors",
    ]

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload Employee's Schedule"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>

                    <div className="popUp-body user-template-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>

                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files?.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files?.length > 0 && (
                        <>
                            {hasNoError ?
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#4cc92a", color: "white"}}>
                                    Data is valid.
                                </div>
                            </>
                            :
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#ce3434", color: "white"}}>
                                    Cannot upload with error.
                                </div>
                            </>
                            }
                            <div className='employeesTab-tab upload-preview-tab' style={{marginTop: "10px"}}>
                                <div id="container1 table-uploads" className="employeesTab-table container">
                                    <CreateTableForUpload
                                        dataList={uploadEmployees_temp}
                                        dataHeader={header}
                                        dataAccessor={accessor}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </div>
                            </div>
                            <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                                {hasNoError && <button id="add-family" 
                                    className="save row"
                                    onClick={(e)=>submit(e)}
                                    style={{marginRight:"5px"}}>
                                        UPLOAD
                                </button>}
                                <button id="add-family" 
                                    className="cancel row"
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                    onClick={()=>handleClose()}>
                                        CANCEL
                                </button>
                            </div>
                        </>
                        )
                    }
                    
                    
                </div>
            )}
            </div>
        </>
    );
}
function ClassificationIdSelect({classificationId, setClassificationId}){
    const handleSelectChange = (event) => {
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Classification/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange}style={{ color: "rgb(104, 104, 104)" }}>
            <option value="" disabled hidden>Choose classification</option>
            {data?.length > 0 && <option value="0">All</option>}
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
            </select>
        </div>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function PayrollPeriodIdSelect({payrollPeriodId, setPayrollPeriodId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayrollPeriodId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        //const currentYear = new Date().getFullYear();
        //const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
        const apiUrl =  domain + `/api/PayrollPeriod/active`; // changed

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(payrollPeriodId !== "" && payrollPeriodId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payrollPeriodId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payrollPeriodId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose payroll period</option>
            {data.map((payrollPeriodId) => ( 
                SetPayrollPeriodId(payrollPeriodId)
            ))}
            </select>
        </div>
    );
};
function SetPayrollPeriodId(payrollPeriodId){
    const formattedDateFrom = format(payrollPeriodId.dateFrom, 'MM/dd/yyyy');
    const formattedDateTo = format(payrollPeriodId.dateTo, 'MM/dd/yyyy');

    return(
        <option value={payrollPeriodId.id}>{`${formattedDateFrom} - ${formattedDateTo} ${payrollPeriodId.payTypeDescription ? payrollPeriodId.payTypeDescription : ""}`}
        </option>
    )
}
export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, editHandleClick, deleteHandleClick, viewSchedule }) {
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows?.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows?.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList?.length <= 0 &&
                        <tr>
                            <td colSpan={columns?.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfo(cell.render("Cell").props.column.Header, 
                                            cell,
                                            editHandleClick,
                                            deleteHandleClick,
                                            viewSchedule
                                        )
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows?.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </>
            ) :
            <></>}
        </>
    )
}
export function CreateTable2({
    dataList = [],
    currentPage,
    setCurrentPage,
    editHandleClick,
    deleteHandleClick,
    viewSchedule,
    payrollPeriodFilter,
    dataToEdit, setDataToEdit,
    handleUpdate
}) {
    // 💡 NEW STATE: Store the ID of the row being edited. 
    // Null means no row is being edited.
    const [editingEmployeeId, setEditingEmployeeId] = useState(null); 

    // Custom edit handler for the component
    const handleEditClick = (employeeData) => {
        // Set the ID of the employee whose row is now editable
        setEditingEmployeeId(employeeData.employeeId);
        setDataToEdit(employeeData)
        
        // You might still want to call the original editHandleClick 
        // to handle any parent component logic (like opening a side panel, etc.)
        if (editHandleClick) {
            editHandleClick(employeeData);
        }
    };
    
    // We also need a way to exit edit mode. Let's make a Cancel handler.
    const handleCancelEdit = () => {
        setEditingEmployeeId(null);
        // You may need to reset data changes here if the user cancels
    };

    const itemsPerPage = 10;

    const [columns, setColumns] = useState([]);
    const [processedData, setProcessedData] = useState([]);
    const [payrollPeriodData, setPayrollPeriodData] = useState(null);
    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    // 🧠 Fetch payroll period data
    const fetchPayrollPeriodData = useCallback(async () => {
        const apiUrl = domain + `/api/PayrollPeriod/${payrollPeriodFilter}`;
        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return null;
        }
    }, [payrollPeriodFilter]);

    useEffect(() => {
        const fetch = async () => {
            const _payrollPeriodData = await fetchPayrollPeriodData();
            setPayrollPeriodData(_payrollPeriodData);
        };
        fetch();
    }, [fetchPayrollPeriodData]);

    // 🧩 Generate columns dynamically based on payrollPeriodData
    useEffect(() => {
        if (!payrollPeriodData?.dateFrom || !payrollPeriodData?.dateTo) return;

        const start = new Date(payrollPeriodData.dateFrom);
        const end = new Date(payrollPeriodData.dateTo);

        const dateColumns = [];
        const current = new Date(start);

        while (current <= end) {
            const dateKey = current.toLocaleDateString("en-CA");
            const formattedDate = `${current.toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
            })}\n${current.toLocaleDateString("en-US", { weekday: "long" })}`;

            dateColumns.push({
                Header: formattedDate,
                accessor: dateKey,
                // 💡 ADD A CUSTOM CELL RENDERER
                //Cell: ({ value }) => (value ? value.shiftName : ''), // Render just the shift name
            });

            current.setDate(current.getDate() + 1);
        }

        const baseColumns = [
            { Header: "Employee Id", accessor: "employeeId" },
            { Header: "Employee Name", accessor: "employeeName" },
            ...dateColumns,
            // { Header: "", accessor: "manage" }
        ];

        setColumns(baseColumns);
    }, [payrollPeriodData]);

    // 🧠 Transform data so each employee row has shift info for each date
    useEffect(() => {
        if (!dataList?.length) return;

        const transformed = dataList.map(employee => {
            const row = {
                employeePersonalInformationId: employee.employeePersonalInformationId,
                employeeId: employee.employeePersonalInformationEmployeeId,
                employeeName: employee.employeePersonalInformationFullName,
                manage: ""
            };

            // For each schedule inside the employee
            employee.schedules?.forEach(schedule => {
                const dateKey = schedule.dateTo?.split("T")[0]; // align with header (dateTo)

                // 💡 CRITICAL CHANGE: Store an object with the ID and the shift name
                row[dateKey] = {
                    id: schedule.id, // The unique ID for this specific schedule entry
                    shiftId: schedule.shiftScheduleToId || "",
                    shiftName: schedule.shiftScheduleToShiftName || "",
                    shiftScheduleFrom: schedule?.shiftScheduleToTimeFrom || "",
                    shiftScheduleTo: schedule?.shiftScheduleToTimeTo || "",
                };
            });

            return row;
        });

        setProcessedData(transformed);
    }, [dataList]);

    // 🔽 Table sorting + pagination setup
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: processedData,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows?.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows?.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // 📊 Sorting behavior
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false });
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true });
                setSortBy([]);
            }
        }
    };

    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [processedData, setSortBy, sortHeaderValue]);

    // 🧾 Render table
    return (
        <>
            <table className='uploading-schedule' {...getTableProps()}>
                <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <th
                                    {...column.getHeaderProps()}
                                    onClick={() => headerClick(column)}
                                    className="sortable-header"
                                    style={{ whiteSpace: "pre-line", textAlign: "center" }} // allow \n to show as line break
                                >
                                    {`${column.render("Header")} ${
                                        sortHeaderValue.id === column.id
                                            ? sortState[
                                                sortHeaderValue.isDefault
                                                    ? 0
                                                    : sortHeaderValue.desc
                                                    ? 2
                                                    : 1
                                            ].textValue
                                            : ""
                                    }`}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {processedData?.length <= 0 && (
                        <tr>
                            <td colSpan={columns?.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    )}
                    {currentItems.map(row => {
                        prepareRow(row);

                        const isCurrentRowBeingEdited = row.original.employeeId === editingEmployeeId;

                        return (
                            <tr key={row.original.employeeId} {...row.getRowProps()}>
                                {row.cells.map(cell =>
                                    SetInfo(
                                        cell.column.Header, // Use cell.column.Header directly
                                        cell,
                                        handleEditClick,
                                        deleteHandleClick,
                                        viewSchedule,
                                        isCurrentRowBeingEdited, // Pass the row-specific edit flag
                                        handleCancelEdit, // Pass the cancel handler
                                        dataToEdit, 
                                        setDataToEdit,
                                        handleUpdate
                                    )
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            {/* Pagination */}
            {rows?.length > itemsPerPage && (
                <>
                    <div
                        className="table-page row"
                        style={{ alignItems: "center", justifyContent: "end", padding: "20px 0 0 0" }}
                    >
                        <button
                            className="prev row"
                            onClick={() => paginate(1)}
                            disabled={currentPage === 1}
                            style={{
                                visibility: currentPage === 1 ? "hidden" : "visible",
                                marginRight: "5px",
                                height: "26px"
                            }}
                        >
                            &lt;&lt;
                        </button>
                        <button
                            className="prev row"
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{
                                visibility: currentPage === 1 ? "hidden" : "visible",
                                marginRight: "5px",
                                height: "26px"
                            }}
                        >
                            <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
                        </button>
                        <button
                            className="next row"
                            onClick={() => paginate(currentPage + 1)}
                            disabled={indexOfLastItem >= rows?.length}
                            style={{
                                visibility: rows?.length > itemsPerPage && !isLastPage ? "visible" : "hidden",
                                marginRight: "5px",
                                height: "26px"
                            }}
                        >
                            NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                        </button>
                        <button
                            className="next row"
                            onClick={() => paginate(totalPages)}
                            disabled={indexOfLastItem >= rows?.length}
                            style={{
                                visibility: rows?.length > itemsPerPage && !isLastPage ? "visible" : "hidden",
                                height: "26px"
                            }}
                        >
                            &gt;&gt;
                        </button>
                    </div>
                    {`${currentPage}/${totalPages}`}
                </>
            )}
        </>
    );
}

function SetInfo(header, _cell, editHandleClick, deleteHandleClick, viewSchedule, isCurrentRowBeingEdited, handleCancelEdit, dataToEdit, setDataToEdit, handleUpdate ) {
    const data = _cell.render("Cell").props.row.original;

    if (header.includes("\n") && header.split("\n").length === 2) {
        // Pass the row-specific flag
        return <EditableDateCell cell={_cell} isEditMode={isCurrentRowBeingEdited} dataToEdit={dataToEdit} setDataToEdit={setDataToEdit}/>;
    }

    // if (header === "") {
    //     if (isCurrentRowBeingEdited) {
    //         return (
    //             <td {..._cell.getCellProps()}>
    //                 <div className="row" style={{alignItems:"center", justifyContent:"center"}}>
    //                     <Tooltip text="Save">
    //                         <div style={{padding:"0 5px", cursor: "pointer"}} onClick={() => { handleUpdate(); handleCancelEdit(); }}>
    //                             <SaveIcon className='bg-white hover:bg-blue-500 hover:text-white cursor-pointer flex items-center justify-center text-blue-500 rounded-md' 
    //                             style={{border: "1px solid #2196F3"}}
    //                             />
    //                         </div>
    //                     </Tooltip>
    //                     <Tooltip text="Cancel">
    //                         <div style={{padding:"0 5px", cursor: "pointer"}} onClick={handleCancelEdit}>
    //                             <CancelIcon className='bg-white hover:bg-red-500 hover:text-white cursor-pointer flex items-center justify-center text-red-500 rounded-md'
    //                             style={{border: "1px solid #F44336"}}
    //                             />
    //                         </div>
    //                     </Tooltip>
    //                 </div>
    //             </td>
    //         );
    //     }

    //     // Show standard buttons (Edit/Delete/View) if not being edited
    //     return(
    //         <td>
    //             <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
    //                 <Tooltip text="Update">
    //                     <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
    //                 </Tooltip>
    //                 { deleteHandleClick ? 
    //                 <Tooltip text="Delete">
    //                     <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
    //                 </Tooltip>
    //                 :
    //                 <></>
    //                 }
    //             </div>
    //         </td>
    //     )
    // }

    if (header === "View") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="View">
                        <div style={{padding:"0 5px"}} onClick={()=>viewSchedule(data)}><CalendarMonthIcon/></div>
                    </Tooltip>
                </div>
            </td>
        )
    }

    if(header === "Status"){
        if(data.isActive){  
            return(
                <td>
                    Active
                </td>
            )
        }
        else{
            return(
                <td>
                    InActive
                </td>
            )
        }
    }

    if(header === "Approved?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.isApproved}
                    disabled={true}
                />
            </td>
        )
    }

    if(header === "Enabled?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.idEnabled}
                    disabled={true}
                />
            </td>
        )
    }

    if(header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
    ){
        const time = _cell.render("Cell").props.value;
        if(!time) {
            return (
                <td>
                </td>
            );
        }

        let timeParts;
        let formattedTime;

        if (globalTimeFormat === "Standard Time"){
            const timeSplit = time.split('T');
            if (timeSplit?.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            // Convert 24-hour format to 12-hour format and determine AM or PM
            const amPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

            formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time"){
            const timeSplit = time.split('T');
            if (timeSplit?.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            formattedTime = `${hours}:${minutes}`;
        }

        return (
            <td>
                {formattedTime}
            </td>
        );
    }
    
    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Date Requested"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    //Double type data
    if(header === "Over Percentage"
    || header === "Deduction"
    || header === "Salary"
    || header === "Employee"
    || header === "Employer"
    || header === "Range From"
    || header === "Range To"
    || header === "Monthly Salary"
    || header === "SSS ER"
    || header === "SSS EE"
    || header === "SSS Total"
    || header === "ECER"
    || header === "Total Contribution ER"
    || header === "Total Contribution EE"
    || header === "Total Contribution Total"
    || header === "SE Total Contribution"
    || header === "Salary Range From"
    || header === "Salary Range To"
    || header === "Total Monthly Premium"
    || header === "Percentage"
    || header === "Amount"
    || header === "Total Loan"
    || header === "Total Balance"
    || header === "Default Deduction"
    || header === "Allowance"
    || header === "Daily Salary"
    || header === "Allowance"
    || header === "Total Basic"
    || header === "Rate"
    || header === "Hours OT Regular"
    || header === "Total OT Regular"
    || header === "Hours OT Exceeded"
    || header === "Total OT Exceeded"
    || header === "Hours OT Restday"
    || header === "Total OT Restday"
    || header === "Hours Holiday Special"
    || header === "Total Holiday Special"
    || header === "Hours Holiday Regular"
    || header === "Total Holiday Regular"
    || header === "Hours Restday Holiday Special"
    || header === "Total Restday Holiday Special"
    || header === "Hours Restday Holiday Regular"
    || header === "Total Restday Holiday Regular"
    || header === "Additions"
    || header === "SSS"
    || header === "Pagibig"
    || header === "Philhealth"
    || header === "SSS Loan"
    || header === "SSS Calamity Loan"
    || header === "Pagibig Loan"
    || header === "Pagibig Calamity Loan"
    || header === "Tax"
    || header === "Deductions"
    || header === "Adjustments"
    || header === "Total Net Pay"
    || header === "Days Absent"
    || header === "Absent/s"
    || header === "Days Leave"
    || header === "Leave/s"
    || header === "Hours Exceeded"
    || header === "Total Exceeded"
    || header === "Hours Undertime"
    || header === "Undertime"
    || header === "Hours Late"
    || header === "Late"
    || header === "Night Diff"
    || header === "OT Regular"
    || header === "OT Restday"
    || header === "Holiday Special"
    || header === "Holiday Regular"
    || header === "Restday Holiday Special"
    || header === "Restday Holiday Regular"
    || header === "Total Absents"
    || header === "Total Late"
    || header === "Total Undertime"
    || header === "Total Leaves"
    || header === "Total Night Diff"
    || header === "Total Exceed"
    || header === "Exceed"
    ){
        const value = _cell.render("Cell").props.value;

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}

// Add this new component outside of CreateTable2

function EditableDateCell({ cell, isEditMode, dataToEdit, setDataToEdit }) {
    // cell.column.Header is the full header: "09/01/2025\nMonday"
    const header = cell.column.Header;
    
    // Check if it's a date column (based on your header format)
    const isDateColumn = header.includes("\n") && header.split("\n").length === 2;
    
    // The value contains { id, shiftName } or is null/undefined
    const cellValue = cell.value;
    
    // Determine the current shift ID. Use the existing one or an empty string.
    const initialShiftId = (cellValue && cellValue.shiftId) ? cellValue.shiftId : "";
    
    // State to hold the temporary selection for THIS cell
    const [shiftScheduleId, setShiftScheduleId] = useState(initialShiftId);

    // *IMPORTANT*: This mock update function should eventually trigger a
    // state update in CreateTable2's parent component to save the changes.
    // For now, it updates local state and logs the change.
    const handleShiftChange = (newShiftId) => {
        setShiftScheduleId(newShiftId);
        
        // Log the change for debugging/demonstration:
        console.log(`Employee ${cell.row.original.employeeId}, Date ${cell.column.id} changed to Shift ID: ${newShiftId}`);
        
        const foundDate = cell.column.id in dataToEdit;

        if (foundDate) {
            // update existing key directly
            setDataToEdit((prev) => ({
                ...prev,
                [cell.column.id]: {
                    ...prev[cell.column.id],
                    shiftId: newShiftId,
                },
            }));
        } else {
            // add a new key if not existing
            setDataToEdit((prev) => ({
                ...prev,
                [cell.column.id]: {
                    shiftId: newShiftId,
                },
            }));
        }
        
        
        // **TO DO**: In a real application, you would call an update function 
        // passed down from the parent here to update the processedData state 
        // in CreateTable2 and/or trigger an API save.
    };

    const formatTime = (time) => {
        if(!time){
            return ""
        }
        let timeParts;
        let formattedTime;

        if (globalTimeFormat === "Standard Time"){
            const timeSplit = time.split('T');
            if (timeSplit?.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            // Convert 24-hour format to 12-hour format and determine AM or PM
            const amPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

            formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time"){
            const timeSplit = time.split('T');
            if (timeSplit?.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            formattedTime = `${hours}:${minutes}`;
        }

        return formattedTime;
    }

    if (isDateColumn) {
        if (isEditMode) {
            // Render the select component when in edit mode
            return (
                <td {...cell.getCellProps()} style={{ textAlign: "center" }}>
                    <ShiftScheduleIdSelectWithNone 
                        shiftScheduleId={shiftScheduleId} 
                        setShiftScheduleId={handleShiftChange} // Use the local handler
                    />
                </td>
            );
        } else {
            // Render the shift name when NOT in edit mode
            return (
                <td {...cell.getCellProps()} style={{ textAlign: "center" }}>
                    <div className='flex flex-col'>
                        <span>{cellValue ? cellValue.shiftName : ''}</span>
                        { cellValue?.shiftScheduleFrom && cellValue?.shiftScheduleTo && <span>{cellValue ? `(${formatTime(cellValue.shiftScheduleFrom)} - ${formatTime(cellValue.shiftScheduleTo)})` : ''}</span>}
                    </div>
                </td>
            );
        }
    }

    // Return default cell for non-date columns if they are not handled by SetInfo
    return (
        <td {...cell.getCellProps()}>
            {cell.render("Cell")}
        </td>
    );
}
function CreateTableForUpload({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [],
    currentPage, setCurrentPage,
}) {
    const itemsPerPage = 7;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows?.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows?.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList?.length <= 0 &&
                        <tr>
                            <td colSpan={columns?.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                className={row.original.error ? "error" : ""}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfoForUpload header={cell.render("Cell").props.column.Header}
                                        _cell={cell}
                                        />
                                    ))}
                                </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows?.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"25px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"25px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoForUpload({header, 
    _cell, 
}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "Photo") {
        if(data.photo){
            const imageSrc = 'data:image/jpeg;base64,' + data.photo;

            return(
                <td>
                    <img className="avatarImg" src={imageSrc} alt=""/>
                </td>
            )
        }
        return(
            <td>
                <img className="avatarImg" src="images/sample.jpg" alt=""/>
            </td>
        )
    }

    if(header === "Date Created"
    ){
        if(!value){
            return (
                <td>
                </td>
            );
        }

        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if(header === "Error"
    ){
        return (
            <td>
                {value && (
                    <p style={{ color: "red", margin: 0 }}>
                        {value}
                    </p>
                )}
            </td>
        );
    }

    if( header === "Vacation Leave"
    || header === "Sick Leave"
    || header === "Service Incentive Leave"
    || header === "Solo Parent Leave"
    || header === "Vacation Leave Remaining"
    || header === "Sick Leave Remaining"
    || header === "Service Incentive Leave Remaining"
    || header === "Solo Parent Leave Remaining"
    ){
        const value = _cell.render("Cell").props.value;

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
export function CreateTableViewSchedule({ dataList = [], setDataList, dataHeader = [], dataAccessor = [],
    deleteHandleClick,
    setWeeklySchedule,

    handleSubmit,
    handleUpdate,

    schedulesAddState,
    setSchedulesAddState,
    schedulesUpdateState,
    setSchedulesUpdateState,

    addHandleClick,
    addHandleClick_cancel,
    updateHandleClick,
    updateHandleClick_cancel,

    dayType,
    setDayType,
    locationId,
    setLocationId,
    shiftScheduleId,
    setShiftScheduleId,
}) {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [recoveredData, setRecoveredData] = useState([]);

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows?.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows?.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const saveAdd = async (e) => {
        await handleSubmit(e);

        addHandleClick_cancel();
        updateHandleClick_cancel();
    }

    const updateClickIn = (data) => {
        addHandleClick_cancel();
        setRecoveredData(data);
        updateHandleClick(data);

        const foundData = dataList.find(_data => _data.id === data.id);

        setDataList(prevDataList => 
            prevDataList.filter(_data => _data.id !== foundData.id)
        );
    }

    const saveUpdate = async (e) => {
        await handleUpdate(e);

        addHandleClick_cancel();
        updateHandleClick_cancel();
    }

    const updateClickIn_cancel = () =>{
        const oldData = {
            id: recoveredData.id,
            employeePersonalInformationId: recoveredData.employeePersonalInformationId,
            employeePersonalInformationEmployeeId: recoveredData.employeePersonalInformationEmployeeId,
            employeePersonalInformationFullName: recoveredData.employeePersonalInformationFullName,
            shiftScheduleId: recoveredData.shiftScheduleId,
            shiftScheduleShiftName: recoveredData.shiftScheduleShiftName,
            locationId: recoveredData.locationId,
            locationDescription: recoveredData.locationDescription,
            day: recoveredData.day,
        }

        setDataList(prevDataList => [
            ...prevDataList, 
            oldData
        ]);

        setDayType("");
        setLocationId("");
        setShiftScheduleId("");

        updateHandleClick_cancel();
    }

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {schedulesAddState &&
                        <tr>
                            <td>
                                <DaySelect dayType={dayType} setDayType={setDayType}/>
                            </td>
                            <td>
                                <LocationIdSelect locationId={locationId} setLocationId={setLocationId}/>
                            </td>
                            <td>
                                <ShiftScheduleIdSelect shiftScheduleId={shiftScheduleId} setShiftScheduleId={setShiftScheduleId}/>
                            </td>
                            <td>
                                <div className="row itinerary-manage"  style={{alignItems:"center", justifyContent:"center"}}>
                                    <Tooltip text="Save">
                                        <div style={{padding:"0 5px"}} onClick={saveAdd}><SaveIcon/></div>
                                    </Tooltip>
                                    <Tooltip text="Cancel">
                                        <div style={{padding:"0 5px"}} onClick={addHandleClick_cancel}><DoDisturbIcon/></div>
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                    }
                    {schedulesUpdateState &&
                        <tr>
                            <td>
                                <DaySelect dayType={dayType} setDayType={setDayType}/>
                            </td>
                            <td>
                                <LocationIdSelect locationId={locationId} setLocationId={setLocationId}/>
                            </td>
                            <td>
                                <ShiftScheduleIdSelect shiftScheduleId={shiftScheduleId} setShiftScheduleId={setShiftScheduleId}/>
                            </td>
                            <td>
                                <div className="row itinerary-manage"  style={{alignItems:"center", justifyContent:"center"}}>
                                    <Tooltip text="Save">
                                        <div style={{padding:"0 5px"}} onClick={saveUpdate}><SaveIcon/></div>
                                    </Tooltip>
                                    <Tooltip text="Cancel">
                                        <div style={{padding:"0 5px"}} onClick={updateClickIn_cancel}><DoDisturbIcon/></div>
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfoViewSchedule(cell.render("Cell").props.column.Header, 
                                        cell,
                                        updateClickIn,
                                        deleteHandleClick
                                    )
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows?.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows?.length}
                        style={{ visibility: (rows?.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </>
            ) :
            <></>}
        </>
    )
}
function SetInfoViewSchedule(header, _cell, editHandleClick, deleteHandleClick) {
    const data = _cell.render("Cell").props.row.original;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};

function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    const formattedDate = date ? date.split('T')[0] : '';

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={formattedDate} // Exclude milliseconds
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function DaySelect({dayType, setDayType}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setDayType(event.target.value);
    };

    useEffect(() => {
        if(dayType !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [dayType]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={dayType} onChange={handleSelectChange}style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose day</option>
            <option value="Monday">Monday</option>
            <option value="Tuesday">Tuesday</option>
            <option value="Wednesday">Wednesday</option>
            <option value="Thursday">Thursday</option>
            <option value="Friday">Friday</option>
            <option value="Saturday">Saturday</option>
            <option value="Sunday">Sunday</option>
            </select>
        </div>
    );
};
function ShiftScheduleIdSelect({shiftScheduleId, setShiftScheduleId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setShiftScheduleId(event.target.value);
    };

    const [shiftScheduleIds, setShiftScheduleIds] = useState([]);

    const apiUrl =  domain + "/api/ShiftSchedule";

    const fetchData = useCallback(async () => {
        await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setShiftScheduleIds(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }, [apiUrl]);

    useEffect(() => {
        fetchData();

        if(shiftScheduleId !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
        
    }, [fetchData, shiftScheduleId]);

    return (
        <div>
            <select id="overtime-employee-name" value={shiftScheduleId} onChange={handleSelectChange} style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose shift schedule</option>
            {shiftScheduleIds.map((shiftScheduleId) => ( 
                SetShiftScheduleId(shiftScheduleId)
            ))}
            </select>
        </div>
    );
};
function ShiftScheduleIdSelectWithNone({ shiftScheduleId, setShiftScheduleId }) {
    const [isSelected, setIsSelected] = useState(false);
    const [shiftScheduleIds, setShiftScheduleIds] = useState([]);
    // 💡 1. Add a loading state
    const [isLoading, setIsLoading] = useState(true);

    const apiUrl = domain + "/api/ShiftSchedule";

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
            setShiftScheduleIds(response.data);
            // 💡 2. Set selection state *after* data has been fetched
            setIsSelected(!!shiftScheduleId);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            // 💡 3. Always turn off loading, even if there's an error
            setIsLoading(false);
        }
    }, [apiUrl, shiftScheduleId]); // Dependency array is key

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setShiftScheduleId(value);
        setIsSelected(value !== "");
    };
    
    // 💡 4. Render a loading indicator while fetching
    if (isLoading) {
        return <div style={{ height: "30px", lineHeight: "30px" }}>...</div>;
    }

    const formatTime = (time) => {
        if(!time){
            return ""
        }
        
        let timeParts;
        let formattedTime;

        if (globalTimeFormat === "Standard Time"){
            const timeSplit = time.split('T');
            if (timeSplit?.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            // Convert 24-hour format to 12-hour format and determine AM or PM
            const amPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

            formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time"){
            const timeSplit = time.split('T');
            if (timeSplit?.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            formattedTime = `${hours}:${minutes}`;
        }

        return formattedTime;
    }

    return (
        <div>
            <select
                id="shift-schedule-select"
                // This logic is now safe because options are guaranteed to exist
                value={shiftScheduleId || ""}
                onChange={handleSelectChange}
                style={{
                    height: "30px",
                    color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)"
                }}
            >
                <option value="">None</option>
                {shiftScheduleIds.map((shift) => (
                    <option key={shift.id} value={shift.id}>
                        {`${shift.shiftName} (${formatTime(shift.timeFrom)} - ${formatTime(shift.timeTo)}) `}
                    </option>
                ))}
            </select>
        </div>
    );
}
function SetShiftScheduleId(shiftScheduleId){
    const formatTime = (time) => {
        if(!time){
            return ""
        }
        let timeParts;
        let formattedTime;

        if (globalTimeFormat === "Standard Time"){
            const timeSplit = time.split('T');
            if (timeSplit?.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            // Convert 24-hour format to 12-hour format and determine AM or PM
            const amPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

            formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time"){
            const timeSplit = time.split('T');
            if (timeSplit?.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            formattedTime = `${hours}:${minutes}`;
        }

        return formattedTime;
    }

    return(
        <option id={"overtimeAdd" + shiftScheduleId.id} value={shiftScheduleId.id}>{`${shiftScheduleId.id} -  ${shiftScheduleId.shiftName} (${formatTime(shiftScheduleId.timeFrom)} - ${formatTime(shiftScheduleId.timeTo)}) `}</option>
    )
    
}
function LocationIdSelectWithAll({locationId, setLocationId}){

    const handleSelectChange = (event) => {
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId} onChange={handleSelectChange}style={{ height: "30px", color: "rgb(104, 104, 104)" }}>
            <option value="0" >All</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function LocationIdSelect({locationId, setLocationId}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(locationId !== "" && locationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [locationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId} onChange={handleSelectChange}style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose location</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
export default UploadedSchedule
